export { default } from "./modal.svelte";

